import * as React from 'react';
import { makeStyles, Button } from '@fluentui/react-components';
import { PHOTO_UPLOAD_CONSTANTS } from '../constants/photoUploadConstants';
import photosQRCode from '../assets/photos_link.png';

const useStyles = makeStyles({
  container: {
    maxWidth: '900px',
    margin: '4rem auto',
    padding: '0 1rem',
  },
  backgroundContainer: {
    backgroundColor: 'rgba(255, 253, 248, 0.95)',
    borderRadius: '16px',
    padding: '2rem 2rem 3rem 2rem',
    boxShadow: '0 8px 24px rgba(12, 59, 94, 0.1)',
    border: '1px solid rgba(12, 59, 94, 0.1)',
    backdropFilter: 'blur(10px)',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    textAlign: 'center',
    lineHeight: '1',
    color: 'var(--primary-color)',
    marginBottom: '1rem',
  },
  description: {
    fontSize: '20px',
    textAlign: 'center',
    color: '#6a8ca3',
    marginBottom: '2rem',
    lineHeight: '1.6',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2rem',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      justifyContent: 'center',
      gap: '3rem',
    },
  },
  qrCodeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  qrCodeImage: {
    width: '200px',
    height: '200px',
    borderRadius: '12px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: '3px solid var(--primary-color)',
  },
  instructionText: {
    fontSize: '20px',
    color: '#6a8ca3',
    textAlign: 'center',
    marginBottom: '1rem',
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  uploadButton: {
    backgroundColor: 'var(--primary-color)',
    border: 'none',
    color: 'white',
    fontSize: '1.1rem',
    fontWeight: '600',
    padding: '12px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'var(--primary-hover)',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 12px rgba(12, 59, 94, 0.3)',
    },
  },
});

const PhotoUploadSection: React.FC = () => {
  const classes = useStyles();

  const handleUploadClick = () => {
    window.open(PHOTO_UPLOAD_CONSTANTS.UPLOAD_LINK, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id={PHOTO_UPLOAD_CONSTANTS.SECTION_ID} className={classes.container} aria-labelledby={PHOTO_UPLOAD_CONSTANTS.TITLE_ID}>
      <div className={classes.backgroundContainer}>
        <h2 id={PHOTO_UPLOAD_CONSTANTS.TITLE_ID} className={classes.sectionTitle}>
          {PHOTO_UPLOAD_CONSTANTS.SECTION_TITLE}
        </h2>
        
        <p className={classes.description}>
          {PHOTO_UPLOAD_CONSTANTS.DESCRIPTION}
        </p>

        <div className={classes.contentWrapper}>
          <div className={classes.qrCodeWrapper}>
            <img 
              src={photosQRCode} 
              alt={PHOTO_UPLOAD_CONSTANTS.QR_CODE_ALT}
              className={classes.qrCodeImage}
            />
          </div>

          <div className={classes.buttonWrapper}>
            <p className={classes.instructionText}>
              {PHOTO_UPLOAD_CONSTANTS.INSTRUCTION_TEXT}
            </p>
            
            <Button 
              className={classes.uploadButton}
              onClick={handleUploadClick}
              size="large"
              appearance="primary"
            >
              {PHOTO_UPLOAD_CONSTANTS.BUTTON_TEXT}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotoUploadSection;